<template>
  <div class="row mb-4 pb-3">
    <div class="col-12">
      <span
        class="dropdown-heading-toggle"
        @click="dropdownIsOpen = !dropdownIsOpen"
        v-if="isDropdown"
        data-test="dropdownHeadingToggle"
      >
        {{ heading }}
        <img class="chevron" :class="{ 'is-open': dropdownIsOpen }" src="@/assets/fa/chevron-down.svg" alt="" />
      </span>
      <div
        v-for="(item, index) in details"
        :key="index"
        :class="{
          'pl-4': isDropdown,
          'pt-2': index > 0 || isDropdown,
          'd-none': index + 1 < details.length && isDropdown && !dropdownIsOpen,
        }"
        class="row"
        data-test="detailItem"
      >
        <div class="col-7" data-test="detailName">
          {{ item.name }}
          <span v-if="item.tooltipIcon" class="tooltip-icon" data-toggle="modal" :data-target="`#${item.tooltipId}`">
            <font-awesome-icon :icon="item.tooltipIcon"></font-awesome-icon>
          </span>
          <div class="small text-muted" v-if="item.msg" data-test="detailMsg">
            {{ item.msg }}
          </div>
        </div>
        <div
          class="col-5 text-right"
          :class="{ 'font-weight-bold text-dark': !isDropdown || index + 1 === details.length }"
          data-test="detailValue"
        >
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentCalculatorDetail',
  data() {
    return {
      dropdownIsOpen: true,
    };
  },
  props: {
    heading: {
      type: String,
      required: false,
    },
    details: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isDropdown() {
      return this.heading;
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-heading-toggle {
  cursor: pointer;
}
.chevron {
  width: 14px;
  height: 14px;
  margin-left: 5px;
  transition: all 0.4s ease;
  &.is-open {
    transform: rotate(-180deg);
  }
}
.tooltip-icon {
  cursor: pointer;
  font-size: 15px;
  padding: 3px;
  top: 1px;
  position: relative;
}
</style>
